import React, { Component } from 'react';
import './Grid.css';

export interface IProps {
    columns: number;
    rows: number;
    highlight?: [number, number];
}

class Grid extends Component<IProps> {
    constructor(props) {
        super(props);
        this.state = {
            userList: []
        };
    }

    render() {
        const fields = [];
        let k = 0;

        for (let i = 0; i < this.props.rows; i++) {
            if (i !== 0) {
                fields.push(<div className="w-100" key={k}></div>);
                k++;
            }
            for (let j = 0; j < this.props.columns; j++) {
                let classNames = ['col', 'field'];
                if (this.props.highlight && this.props.highlight[0] === i &&
                    this.props.highlight[1] === j) {
                    classNames.push('highlight');
                }
                fields.push(
                    <div className={classNames.join(' ')} key={k}></div>
                );
                k++;
            }
        }

        return (
            <div className="Container">                               
                <div className="row-game">
                    <div className="col">
                        <div className="Grid">
                            <div className="container">
                                <div className="row">
                                    {fields}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-auto">
                    </div>
                </div>
            </div>
        );
    }
}

export default Grid;